import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
} from '@angular/core';

import { WorkflowFormFieldOutputRequestFieldPopulated } from '@features/requests/request-form/components/request-form-workflows/types';
import { TextCopierComponent } from '@core/components';
import { getRequestFieldLabel } from './request-field-labels';

const dateRequestFields = [
  'contractDate',
  'contractPlannedEndDate',
  'contractEarlyEndDate',
  'releaseDate',
  'actualReleaseDate',
  'actualReleaseDate',
  'completedAt',
  'lesseeSigningDate',
  'releaseDateUpdatedAt',
  'createdAt',
  'updatedAt',
];

@Component({
  selector: 'x-output-request-field',
  imports: [TextCopierComponent],
  templateUrl: './output-request-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class OutputRequestFieldComponent {
  field = input.required<WorkflowFormFieldOutputRequestFieldPopulated>();

  // Вычисляемый заголовок: если title не указан, берем из словаря по requestFieldName
  $displayTitle = computed(() => {
    const field = this.field();

    return field.title || getRequestFieldLabel(field.requestFieldName);
  });

  constructor() {
    effect(() => {
      const field = this.field();

      if (field) {
        if (dateRequestFields.includes(field.requestFieldName)) {
          field.requestFieldValue = this.parseDateFields(
            field.requestFieldValue as string,
          );
        }
      }
    });
  }

  parseDateFields(dateString: string): string {
    const date = new Date(dateString);

    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
}
